import React, { useState } from "react";
import styles from "../BuilderIO/FinalSalePDP/FinalSalePDP.module.scss";

const ExchangeOnlyMessage = () => {
    const message = "This item is size exchange only and cannot be returned"

    return (
        <div className={`${styles.finalSaleBanner}`} style={{ backgroundColor: "#f2edea", color: "#2f2f30" }}>
            <p className={`text-sm`}>{message}</p>
        </div>)

}

export default ExchangeOnlyMessage;